<!-- <section class="header-bg">
<div class="container-lg">
  <div class="row align-items-center justify-content-center">
    <div class="image col">
      <img
        src="/assets/marktbox-header-00.webp"
        alt="Aufgebauter marktbox Verkaufsautomat"
        />
    </div>
  </div>
</div>
</section> -->
<div class="section section--bordered" id="top ">
  <div class="content">
    <div class="field field--small">
      <h3 class="section__caption" [innerHTML]=" content['section.caption'] ">
      </h3>
    </div>
  </div>
</div>
<div class="section">
  <div class="content">
    <div class="field">
      <div class="caption" [innerHTML]=" content['header.caption'] "></div>
      <h1 class="display" [innerHTML]=" content['header.display'] "></h1>
      <div class="copy" [innerHtml]="content['header.copy']"></div>
    </div>
  </div>
</div>
<div class="topic topic--1" [class.inactive]="!active[0]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.1.question']" (click)="toggleActive(0)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.1.answer']"></div>
      </div>
    </div>
  </div>
  <div class="section section--light">
    <div class="content">
      <div class="topic__boxes--wrapper">
        <div class="field field--small">
          <div class="topic__boxes">
            @for (box of content['faq.1.boxes']; track box) {
            <div class="box topic__box">
              <app-svg class="box__icon" [svg]="'/assets/icons/' + box.icon + '.svg'"></app-svg>
              <h4 class="box__title" [innerHTML]=" box.title ">
              </h4>
              <p class="box__text" [innerHTML]=" box.text ">
              </p>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="topic topic--2" [class.inactive]="!active[1]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.2.question']" (click)="toggleActive(1)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.2.answer']"></div>
      </div>
    </div>
  </div>
  @for (child of content['faq.2.children']; track child; let i = $index) {
  <div class="topic topic--2-{{ i + 1 }}" [class.inactive]="!active[2 + i]">
    <div class="section">
      <div class="content content--inset">
        <app-topic-head class="topic__head" [text]="child.question" (click)="toggleActive(i + 2)"></app-topic-head>
        <div class="topic__content topic__content--inset">
          <div class="answer" [innerHTML]="child.answer"></div>
        </div>
      </div>
    </div>
    @if (child.boxTable) {
    <div class="section section--light">
      <div class="content content--inset">
        <div class="topic__boxes--wrapper">
          <div class="field field--small">
            <div class="caption" [innerHTML]=" child.boxTitle ">
            </div>
            <div class="topic__table" [innerHTML]="child.boxTable"></div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
<div class="topic topic--3" [class.inactive]="!active[7]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.3.question']" (click)="toggleActive(7)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.3.answer']"></div>
      </div>
    </div>
  </div>
  @for (child of content['faq.3.children']; track child; let i = $index) {
  <div class="topic topic--3-{{ i + 1 }}" [class.inactive]="!active[8 + i]">
    <div class="section">
      <div class="content content--inset">
        <app-topic-head class="topic__head" [text]="child.question" (click)="toggleActive(8 + i)"></app-topic-head>
        <div class="topic__content">
          <div class="answer" [innerHTML]="child.answer"></div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
<div class="topic topic--4" [class.inactive]="!active[11]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.4.question']"
        (click)="toggleActive(11)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.4.answer']"></div>
      </div>
    </div>
  </div>
  @for (child of content['faq.4.children']; track child; let i = $index) {
  <div [class.inactive]="!active[12 + i]" class="topic topic-4-{{ i + 1 }}">
    <div class="section">
      <div class="content content--inset">
        <app-topic-head class="topic__head" [text]="child.question" (click)="toggleActive(12 + i)"></app-topic-head>
        <div class="topic__content">
          <div class="answer" [innerHTML]="child.answer"></div>
        </div>
      </div>
    </div>
    @if (i == 2) {
    <div class="section section--light">
      <div class="content content--inset">
        <div class="topic__boxes--wrapper">
          <div class="field field--small">
            <div class="topic__boxes topic__boxes--three">
              @for (text of content['faq.4.3.boxes']; track text) {
              <div class="topic__box box box--text-only">
                <p class="box__text" [innerHTML]=" text ">
                </p>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
<div class="topic topic--5" [class.inactive]="!active[15]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.5.question']"
        (click)="toggleActive(15)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.5.answer']"></div>
      </div>
    </div>
  </div>
</div>
<div class="topic topic--6" [class.inactive]="!active[16]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.6.question']"
        (click)="toggleActive(16)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.6.answer']"></div>
      </div>
    </div>
  </div>
</div>
<div class="topic topic--7" [class.inactive]="!active[17]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.7.question']"
        (click)="toggleActive(17)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.7.answer']"></div>
      </div>
    </div>
  </div>
</div>
<div class="topic topic--8" [class.inactive]="!active[18]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.8.question']"
        (click)="toggleActive(18)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.8.answer']"></div>
      </div>
    </div>
  </div>
</div>
<div class="topic topic--9" [class.inactive]="!active[19]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.9.question']"
        (click)="toggleActive(19)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.9.answer']"></div>
      </div>
    </div>
  </div>
  <div class="section section--light">
    <div class="content">
      <div class="field field--small">
        <app-tipp [content]="content['faq.9.tipp']"></app-tipp>
      </div>
    </div>
  </div>
</div>
<div class="topic topic--10" [class.inactive]="!active[20]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.10.question']"
        (click)="toggleActive(20)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.10.answer']"></div>
      </div>
    </div>
  </div>
  @for (child of content['faq.10.children']; track child) {
  <div class="section section--wide">
    <div class="content">
      <div class="caption" [innerHTML]=" child.title ">
      </div>
      <div class="answer" [innerHTML]="child.text"></div>
    </div>
  </div>
  @if (child.tipp) {
  <div class="section section--light">
    <div class="content">
      <div class="field">
        <app-tipp [content]="child.tipp"></app-tipp>
      </div>
    </div>
  </div>
  }
  }
</div>
<div class="topic topic--11" [class.inactive]="!active[21]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.11.question']"
        (click)="toggleActive(21)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.11.answer']"></div>
      </div>
    </div>
  </div>
  <div class="section section--light">
    <div class="content content--inset">
      <div class="topic__boxes--wrapper">
        <div class="field field--small">
          <div class="topic__boxes">
            @for (box of content['faq.11.boxes']; track box) {
            <div class="box topic__box">
              <app-svg class="box__icon" [svg]="'/assets/icons/' + box.icon + '.svg'"></app-svg>
              <h4 class="box__title" [innerHTML]=" box.title ">
              </h4>
              <p class="box__text" [innerHTML]=" box.text ">
              </p>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="topic topic--12" [class.inactive]="!active[22]">
  <div class="section">
    <div class="content">
      <app-topic-head class="topic__head" [text]="content['faq.12.question']"
        (click)="toggleActive(22)"></app-topic-head>
      <div class="topic__content">
        <div class="answer" [innerHTML]="content['faq.12.answer']"></div>
      </div>
    </div>
  </div>
</div>